<template>
    <div class="animated fadeIn">
        <ResourceTable
            ref="resourceTable"
            resource-name="groups/search"
            :query="searchQuery"
            :filter="dataFilter"
            :fields="selectedFields"
            :include="['grouptype']"
        >
            <Tabs default-tab="groups" />
            <h1>{{ $t('label.groups') }}</h1>

            <!-- FilterRow -->
            <b-row style="margin-bottom: 10px">
                <b-col sm="12" md="4" v-if="false">
                    <div style="font-weight: bold">
                        {{ $t('label.chooseFilter') }}
                    </div>
                </b-col>

                <b-col sm="12" md="4">
                    <b>{{ $t('label.filter') }}</b>
                    <a-input-search v-model="searchQuery" />
                </b-col>
                <b-col sm="12" md="3">
                    <div style="font-weight: bold">
                        {{ $t('label.fields') }}
                    </div>
                    <a-select
                        :defaultValue="defaultFields"
                        @select="onFieldChange"
                        @deselect="onFieldDeselect"
                        mode="multiple"
                        style="width: 100%"
                    >
                        <a-select-option
                            v-for="field in fields"
                            :key="field.key"
                            >{{ field.label }}</a-select-option
                        >
                    </a-select>
                </b-col>
                <b-col sm="12" md="2">
                    <div>&nbsp;</div>
                    <a-button
                        type="primary"
                        @click="$refs.resourceTable.downloadCollection()"
                    >
                        <i class="fa fa-file-excel-o" />
                        <span>&nbsp; {{ $t('label.exportToExcel') }}</span>
                    </a-button>
                </b-col>
            </b-row>

            <!-- Actions -->
            <template slot="actions" slot-scope="row">
                <router-link :to="createGroupLink(row.item.data.id)">
                    <a-button
                        size="small"
                        shape="circle"
                        :title="$t('label.goTo')"
                    >
                        <a-icon type="right" />
                    </a-button>
                </router-link>
            </template>
            <!-- <template slot="details" slot-scope="row">
                <a-card>
                    <a-button type="primary">
                        <a :href="'mailto:' + row.item.data.email"
                            >Send email</a
                        > </a-button
                    >&nbsp;
                    <a-button type="dashed">
                        <a
                            v-if="authIsManager"
                            :href="
                                '/organization/' +
                                    $route.params.orgId +
                                    '/users/' +
                                    row.item.data.id
                            "
                            >Edit user</a
                        >
                    </a-button>
                </a-card>
            </template>-->
        </ResourceTable>
    </div>
</template>

<script>
const fields = [
    {
        key: 'name',
        label: 'label.name',
        sortable: false,
        sortDirection: 'asc',
    },
    {
        key: 'grouptype.name',
        label: 'label.grouptype',
    },
    {
        label: 'label.displayname',
        key: 'display_name',
        sortable: false,
    },
    {
        key: 'description',
        label: 'label.description',
        sortable: false,
    },
]

import ResourceTable from '@/components/ResourceTable'

import { mapGetters, mapActions } from 'vuex'
import Tabs from '../__Tabs__'

export default {
    components: {
        ResourceTable,
        Tabs,
    },

    data() {
        return {
            // fields: fields,
            defaultFields: ['display_name', 'grouptype.name', 'description'],
            selectedFieldsKeys: [],
            searchQuery: '',
            dataFilter: {
                company_id: this.$route.params.orgId,
            },
        }
    },

    created() {
        this.selectedFieldsKeys = this.defaultFields
    },

    methods: {
        ...mapActions({}),

        onFieldChange(key) {
            this.selectedFieldsKeys.push(key)
        },

        createGroupLink(groupId) {
            return (
                '/organization/' +
                this.$route.params.orgId +
                '/groups/' +
                groupId
            )
        },

        onFieldDeselect(key) {
            this.selectedFieldsKeys.splice(this.selectedFields.indexOf(key), 1)
        },

        closeShowSelectUnitModal() {
            this.showSelectUnitModal = false
        },

        getBtnType(mode) {
            return mode == this.unitFilterMode ? 'primary' : 'default'
        },
    },
    computed: {
        ...mapGetters({
            user: 'auth/user',
            authIsManager: 'auth/isManager',
            unitsLoading: 'companies/isLoading',
            companies: 'companies/list',
        }),

        fields() {
            return fields.map(field => {
                field['label'] = this.$t(field.label)
                return field
            })
        },

        selectedFields() {
            return this.selectedFieldsKeys
                .map(k => {
                    return this.fields.filter(f => f.key == k)[0]
                })
                .map(f => {
                    if (!f.path) {
                        f.path = f.key
                    }
                    return f
                })
        },
    },
}
</script>
